export const LOAD_REPORT_REQUEST = 'ReportPage/LOAD_REPORT_REQUEST';
export const LOAD_REPORT_SUCCESS = 'ReportPage/LOAD_REPORT_SUCCESS';
export const LOAD_REPORT_FAILURE = 'ReportPage/LOAD_REPORT_FAILURE';
export const UPDATE_TICKET_DEPARTMENT_REQUEST = 'ReportPage/UPDATE_TICKET_DEPARTMENT_REQUEST';
export const UPDATE_TICKET_DEPARTMENT_SUCCESS = 'ReportPage/UPDATE_TICKET_DEPARTMENT_SUCCESS';
export const UPDATE_TICKET_DEPARTMENT_FAILURE = 'ReportPage/UPDATE_TICKET_DEPARTMENT_FAILURE';
